(function () {
  'use strict';

  var storage = window.HpEntryStorage;

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function onSignup(email) {
    if (!storage) return;
    storage.setEmail(email);
    storage.assignEntry(true);
  }

  function bindKlaviyoForm(container) {
    if (container.dataset.rlEmailBound) return;

    function attach(input) {
      if (container.dataset.rlEmailBound) return;
      container.dataset.rlEmailBound = '1';

      function persistEmail() {
        if (!storage || !isValidEmail(input.value)) return;
        storage.setEmail(input.value);
      }

      function persistSignup() {
        if (!isValidEmail(input.value)) return;
        onSignup(input.value);
      }

      input.addEventListener('input', persistEmail);
      input.addEventListener('change', persistEmail);
      input.addEventListener('blur', persistEmail);

      var form = input.closest('form');
      if (form) {
        form.addEventListener('submit', persistSignup);
      }

      container.addEventListener('click', function (e) {
        if (!e.target.closest('button')) return;
        persistSignup();
      }, true);
    }

    function tryBind() {
      var input = container.querySelector('input[type="email"]');
      if (input) attach(input);
      return !!input;
    }

    if (tryBind()) return;

    var observer = new MutationObserver(function () {
      tryBind();
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function bindShopifyForm(form) {
    if (form.dataset.rlEmailBound) return;

    var input = form.querySelector('input[name="contact[email]"]');
    if (!input) return;

    form.dataset.rlEmailBound = '1';

    form.addEventListener('submit', function () {
      onSignup(input.value);
    });

    if (input.value && isValidEmail(input.value)) {
      if (storage) storage.setEmail(input.value);
    }
  }

  function onKlaviyoFormsEvent(event) {
    var detail = event && event.detail;
    if (!detail || detail.type !== 'submit') return;

    var meta = detail.metaData || {};
    var email = meta.$email || meta.email || '';
    onSignup(email);
  }

  function init() {
    if (!storage) return;
    document.querySelectorAll('.raffle-lp-signup__klaviyo-form').forEach(bindKlaviyoForm);
    document.querySelectorAll('.raffle-lp-signup__form:not(.raffle-lp-signup__klaviyo-form)').forEach(bindShopifyForm);
    window.addEventListener('klaviyoForms', onKlaviyoFormsEvent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
